<template>
  <div>
    <div class="message">
      <Message class="msg" severity="info">Die Reklamationsliste wird zum 01.01.2026 abgeschaltet, und Nicht Länger zur
        Verfügung stehen. Für Administratoren steht nun die Möglichkeit zur Verfügung zu jeglicher zeit Die Daten aus
        der Reklamationsliste als xlsx (Excel) Tabelle Herunterzuladen.</Message>
    </div>
    <Toast group="bc" position="bottom-center" />
    <Toast group="tc" position="top-center" />
    <Toast />

    <div style="min-height: 100vh; display: flex; flex-direction: row; width: 100%;">
      <Sidebar v-if="currentTab.name != 'login'" />

      <div style="padding: 1rem; width: calc(100% - 17.5rem);">
        <MaintenancePopUp header="Abschaltung der Reklamationsliste" message="Liebe Nutzerinnen und Nutzer, <br><br>
    als Gründer möchte ich mich herzlich bei Ihnen für die Nutzung unserer Reklamationsliste bedanken. <br><br>
    Bitte beachten Sie: Die Reklamationsliste wird <strong>zum 01.01.2026 abgeschaltet</strong> und steht danach <strong>nicht mehr zur Verfügung</strong>. <br>
    Administratoren haben jedoch bereits jetzt die Möglichkeit, <strong>alle Daten jederzeit als Excel-Datei (.xlsx) herunterzuladen</strong>. Bitte sichern Sie Ihre Daten rechtzeitig, um Verluste zu vermeiden. <br><br>
    Vielen Dank für Ihr Vertrauen und Ihre Unterstützung! <br><br>
    Mit freundlichen Grüßen <br>
    <strong>Lee Daniel Hertel</strong> <br>
    <i>Gründer der Reklamationsliste</i> <br><br>
    <h4>Zum Schließen dieser Nachricht: das 'X' oben rechts klicken</h4>" saveCookie="true" />
        <Dialog v-model:visible="visible" modal header="Edit Profile" :style="{ width: '25rem' }">
          <span class="text-surface-500 dark:text-surface-400 block mb-8">Update your information.</span>
        </Dialog>

        <RouterView />
      </div>
    </div>
  </div>
</template>

<script>
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { RouterView, useRouter } from 'vue-router';
import Sidebar from './components/Sidebar.vue';
import { useAuthStore } from './stores/auth.js';
import MaintenancePopUp from './components/MaintenancePopUp.vue';
import Message from 'primevue/message';

export default {
  components: {
    Toast,
    Dialog,
    Button,
    RouterView,
    Sidebar,
    MaintenancePopUp,
    Message,
  },
  data() {
    return {
      visible: false,
      currentTab: useRouter().currentRoute,
    };
  },
  mounted() {
    useAuthStore().initializeAuthStore();
  },
};
</script>
<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

p-message-content {
  text-align: center;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
